module.exports = __webpack_public_path__ + "static/img/logo-inverted.194714f1.svg";